import React from "react";
import { Avatar, Breadcrumb, Button, Card, Col, Drawer, Form, Input, Layout, Modal, Pagination, Row, Select, Spin, Switch, Tag, Timeline, Typography, Upload, message } from "antd";
import { Link, Navigate } from "react-router-dom";

import { IoCameraOutline, IoLockOpen, IoPencil, IoReturnUpBackOutline, IoTrash } from "react-icons/io5";
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { POST_API, POST_CATCH, getToken, getUPLOADAPI, titleWeb, verifyConfig } from "../../../services/api";

// COMPONENTS
import Table from '../../../components/Table';

// CONTROLLER
import Page403 from '../../Controller/Page403';
import ReactInputMask from "react-input-mask";

class AdminWiki extends React.Component {

    state = {
        _navigate: false,
        _loading: false,
        tribunal: null,
        pagination: { current: 1, total: 0, limit: 10 },
        data: [],
        processo: '',
        prev: '',
        next: '',
        itemSelect: null
    }

    back = "/painel/wiki";

    routes = [
        {title: <Link to={this.back}>Wiki</Link>}
    ]

    componentDidMount = () => {
        titleWeb('Wiki')
    }
    
    // LOAD DATA
    onView = (page, type = 'next') => {

        if (this.state.tribunal) {

            this.setState({_loading: true})

            var pagination = JSON.stringify(this.state.pagination)

            POST_API('/datajud/search.php', { token: getToken(), tribunal: this.state.tribunal, processo: this.state.processo, pagination, after: page === 1 ? '' : type === 'next' ? this.state.next : this.state.prev }).then(rs => rs.json()).then(res => {
                this.setState({
                    pagination: {
                        current: page,
                        total: res.hits.total.value,
                        limit: 10,
                    },
                    data: res.hits.hits,
                    next: res.hits.hits.length > 0 ? res.hits.hits.slice(-1)[0].sort[0] : '',
                })
            }).finally(() => {
                console.log(this.state.prev, this.state.next)
                this.setState({_loading: false})
            })

        } else {
            message.warning('Selecione um tribunal')
        }
        
    }

    onPrev = () => {
        this.onView(this.state.pagination.current - 1, 'prev')
    }

    onNext = () => {
        this.setState({
            prev: this.state.data[1].sort[0],
        })
        this.onView(this.state.pagination.current + 1, 'next')
    }

    tribunais = [
        { label: 'Tribunal Superior do Trabalho', value: 'api_publica_tst' },
        { label: 'Tribunal Superior Eleitoral', value: 'api_publica_tse' },
        { label: 'Tribunal Superior de Justiça', value: 'api_publica_stj' },
        { label: 'Tribunal Superior Militar', value: 'api_publica_stm' },
        { label: 'Tribunal Regional Federal da 1ª Região', value: 'api_publica_trf1' },
        { label: 'Tribunal Regional Federal da 2ª Região', value: 'api_publica_trf2' },
        { label: 'Tribunal Regional Federal da 3ª Região', value: 'api_publica_trf3' },
        { label: 'Tribunal Regional Federal da 4ª Região', value: 'api_publica_trf4' },
        { label: 'Tribunal Regional Federal da 5ª Região', value: 'api_publica_trf5' },
        { label: 'Tribunal Regional Federal da 6ª Região', value: 'api_publica_trf6' },
        { label: 'Tribunal de Justiça do Acre', value: 'api_publica_tjac' },
        { label: 'Tribunal de Justiça de Alagoas', value: 'api_publica_tjal' },
        { label: 'Tribunal de Justiça do Amazonas', value: 'api_publica_tjam' },
        { label: 'Tribunal de Justiça do Amapá', value: 'api_publica_tjap' },
        { label: 'Tribunal de Justiça da Bahia', value: 'api_publica_tjba' },
        { label: 'Tribunal de Justiça do Ceará', value: 'api_publica_tjce' },
        { label: 'TJ do Distrito Federal e Territórios', value: 'api_publica_tjdft' },
        { label: 'Tribunal de Justiça do Espírito Santo', value: 'api_publica_tjes' },
        { label: 'Tribunal de Justiça do Goiás', value: 'api_publica_tjgo' },
        { label: 'Tribunal de Justiça do Maranhão', value: 'api_publica_tjma' },
        { label: 'Tribunal de Justiça de Minas Gerais', value: 'api_publica_tjmg' },
        { label: 'TJ do Mato Grosso de Sul', value: 'api_publica_tjms' },
        { label: 'Tribunal de Justiça do Mato Grosso', value: 'api_publica_tjmt' },
        { label: 'Tribunal de Justiça do Pará', value: 'api_publica_tjpa' },
        { label: 'Tribunal de Justiça da Paraíba', value: 'api_publica_tjpb' },
        { label: 'Tribunal de Justiça de Pernambuco', value: 'api_publica_tjpe' },
        { label: 'Tribunal de Justiça do Piauí', value: 'api_publica_tjpi' },
        { label: 'Tribunal de Justiça do Paraná', value: 'api_publica_tjpr' },
        { label: 'Tribunal de Justiça do Rio de Janeiro', value: 'api_publica_tjrj' },
        { label: 'TJ do Rio Grande do Norte', value: 'api_publica_tjrn' },
        { label: 'Tribunal de Justiça de Rondônia', value: 'api_publica_tjro' },
        { label: 'Tribunal de Justiça de Roraima', value: 'api_publica_tjrr' },
        { label: 'Tribunal de Justiça do Rio Grande do Sul', value: 'api_publica_tjrs' },
        { label: 'Tribunal de Justiça de Santa Catarina', value: 'api_publica_tjsc' },
        { label: 'Tribunal de Justiça de Sergipe', value: 'api_publica_tjse' },
        { label: 'Tribunal de Justiça de São Paulo', value: 'api_publica_tjsp' },
        { label: 'Tribunal de Justiça do Tocantins', value: 'api_publica_tjto' },
        { label: 'Tribunal Regional do Trabalho da 1ª Região', value: 'api_publica_trt1' },
        { label: 'Tribunal Regional do Trabalho da 2ª Região', value: 'api_publica_trt2' },
        { label: 'Tribunal Regional do Trabalho da 3ª Região', value: 'api_publica_trt3' },
        { label: 'Tribunal Regional do Trabalho da 4ª Região', value: 'api_publica_trt4' },
        { label: 'Tribunal Regional do Trabalho da 5ª Região', value: 'api_publica_trt5' },
        { label: 'Tribunal Regional do Trabalho da 6ª Região', value: 'api_publica_trt6' },
        { label: 'Tribunal Regional do Trabalho da 7ª Região', value: 'api_publica_trt7' },
        { label: 'Tribunal Regional do Trabalho da 8ª Região', value: 'api_publica_trt8' },
        { label: 'Tribunal Regional do Trabalho da 9ª Região', value: 'api_publica_trt9' },
        { label: 'Tribunal Regional do Trabalho da 10ª Região', value: 'api_publica_trt10' },
        { label: 'Tribunal Regional do Trabalho da 11ª Região', value: 'api_publica_trt11' },
        { label: 'Tribunal Regional do Trabalho da 12ª Região', value: 'api_publica_trt12' },
        { label: 'Tribunal Regional do Trabalho da 13ª Região', value: 'api_publica_trt13' },
        { label: 'Tribunal Regional do Trabalho da 14ª Região', value: 'api_publica_trt14' },
        { label: 'Tribunal Regional do Trabalho da 15ª Região', value: 'api_publica_trt15' },
        { label: 'Tribunal Regional do Trabalho da 16ª Região', value: 'api_publica_trt16' },
        { label: 'Tribunal Regional do Trabalho da 17ª Região', value: 'api_publica_trt17' },
        { label: 'Tribunal Regional do Trabalho da 18ª Região', value: 'api_publica_trt18' },
        { label: 'Tribunal Regional do Trabalho da 19ª Região', value: 'api_publica_trt19' },
        { label: 'Tribunal Regional do Trabalho da 20ª Região', value: 'api_publica_trt20' },
        { label: 'Tribunal Regional do Trabalho da 21ª Região', value: 'api_publica_trt21' },
        { label: 'Tribunal Regional do Trabalho da 22ª Região', value: 'api_publica_trt22' },
        { label: 'Tribunal Regional do Trabalho da 23ª Região', value: 'api_publica_trt23' },
        { label: 'Tribunal Regional do Trabalho da 24ª Região', value: 'api_publica_trt24' },
        { label: 'Tribunal Regional Eleitoral do Acre', value: 'api_publica_tre-ac' },
        { label: 'Tribunal Regional Eleitoral de Alagoas', value: 'api_publica_tre-al' },
        { label: 'Tribunal Regional Eleitoral do Amazonas', value: 'api_publica_tre-am' },
        { label: 'Tribunal Regional Eleitoral do Amapá', value: 'api_publica_tre-ap' },
        { label: 'Tribunal de Justiça da Bahia', value: 'api_publica_tre-ba' },
        { label: 'Tribunal Regional Eleitoral do Ceará', value: 'api_publica_tre-ce' },
        { label: 'Tribunal Regional Eleitoral do Distrito Federal', value: 'api_publica_tre-dft' },
        { label: 'Tribunal Regional Eleitoral do Espírito Santo', value: 'api_publica_tre-es' },
        { label: 'Tribunal Regional Eleitoral do Goiás', value: 'api_publica_tre-go' },
        { label: 'Tribunal Regional Eleitoral do Maranhão', value: 'api_publica_tre-ma' },
        { label: 'Tribunal Regional Eleitoral de Minas Gerais', value: 'api_publica_tre-mg' },
        { label: 'Tribunal Regional Eleitoral do Mato Grosso de Sul', value: 'api_publica_tre-ms' },
        { label: 'Tribunal Regional Eleitoral do Mato Grosso', value: 'api_publica_tre-mt' },
        { label: 'Tribunal Regional Eleitoral do Pará', value: 'api_publica_tre-pa' },
        { label: 'Tribunal Regional Eleitoral da Paraíba', value: 'api_publica_tre-pb' },
        { label: 'Tribunal Regional Eleitoral de Pernambuco', value: 'api_publica_tre-pe' },
        { label: 'Tribunal Regional Eleitoral do Piauí', value: 'api_publica_tre-pi' },
        { label: 'Tribunal Regional Eleitoral do Paraná', value: 'api_publica_tre-pr' },
        { label: 'Tribunal Regional Eleitoral do Rio de Janeiro', value: 'api_publica_tre-rj' },
        { label: 'Tribunal Regional Eleitoral do Rio Grande do Norte', value: 'api_publica_tre-rn' },
        { label: 'Tribunal Regional Eleitoral de Rondônia', value: 'api_publica_tre-ro' },
        { label: 'Tribunal Regional Eleitoral de Roraima', value: 'api_publica_tre-rr' },
        { label: 'Tribunal Regional Eleitoral do Rio Grande do Sul', value: 'api_publica_tre-rs' },
        { label: 'Tribunal Regional Eleitoral de Santa Catarina', value: 'api_publica_tre-sc' },
        { label: 'Tribunal Regional Eleitoral de Sergipe', value: 'api_publica_tre-se' },
        { label: 'Tribunal Regional Eleitoral de São Paulo', value: 'api_publica_tre-sp' },
        { label: 'Tribunal Regional Eleitoral do Tocantins', value: 'api_publica_tre-to' },
        { label: 'Tribunal Justiça Militar de Minas Gerais', value: 'api_publica_tjmmg' },
        { label: 'Tribunal Justiça Militar do Rio Grande do Sul', value: 'api_publica_tjmrs' },
        { label: 'Tribunal Justiça Militar de São Paulo', value: 'api_publica_tjmsp' },
    ]

    formatData = (data) => {
        const date = new Date(data);

        const formattedDate = date.toLocaleString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false, // Para hora no formato 24h
        });

        return formattedDate;
    }

    render = () => {

        return (
            <Layout>
                <Layout.Content className={`admin-container`}>
                    <Row gutter={[8,8]} align={'middle'}>
                        <Col span={18}>
                            <Breadcrumb items={this.routes} />
                        </Col>
                        <Col span={6} style={{display: 'flex', justifyContent: 'flex-end'}}>
                            
                        </Col>
                        <Col span={24}>
                            <Card>
                                <Row gutter={[8,8]}>
                                    <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                                        <Typography>Tribunal</Typography>
                                        <Select value={this.state.tribunal} onChange={(e) => this.setState({tribunal: e})} placeholder="Selecione o tribunal onde fará a pesquisa" options={this.tribunais} style={{width: '100%'}} />
                                    </Col>
                                    <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                                        <Typography>Número do processo</Typography>
                                        <Input value={this.state.processo} onChange={(e) => this.setState({processo: e.target.value})} placeholder="Digite o número do processo" style={{width: '100%'}} />
                                    </Col>
                                    <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                                        <Button type="primary" block onClick={() => this.onView(1)} loading={this.state._loading}>Buscar</Button>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                        { this.state._loading ? <Col span={24}><Card><center><Spin /></center></Card></Col> : !(this.state.data.length > 0) ? <Col span={24}><Card>Nenhum processo encontrado</Card></Col> : this.state.data.map((item, index) => (
                            <Col span={24} key={index}>
                                <Card hoverable onClick={() => this.setState({itemSelect: item})}>
                                    <Row gutter={[8,8]}>
                                        <Col span={24}>
                                            <Typography className="datajud-title">Número do processo</Typography>
                                            <Typography className="datajud-text">{item._source.numeroProcesso}</Typography>
                                        </Col>
                                        <Col span={24}>
                                            <Typography className="datajud-title">Última atualização</Typography>
                                            <Typography className="datajud-text">{this.formatData(item._source.dataHoraUltimaAtualizacao)}</Typography>
                                        </Col>
                                        <Col span={24}>
                                            <Typography className="datajud-title">Data do ajuizamento</Typography>
                                            <Typography className="datajud-text">{this.formatData(item._source.dataAjuizamento)}</Typography>
                                        </Col>
                                        <Col span={24}>
                                            <Typography className="datajud-title">Orgão julgador</Typography>
                                            <Typography className="datajud-text">{item._source.orgaoJulgador.codigo} - {item._source.orgaoJulgador.nome}</Typography>
                                        </Col>
                                        <Col span={24}>
                                            <Typography className="datajud-title">Classe</Typography>
                                            <Typography className="datajud-text">{item._source.classe.codigo} - {item._source.classe.nome}</Typography>
                                        </Col>
                                        <Col span={24}>
                                            <Typography className="datajud-title">Assuntos</Typography>
                                            { item._source.assuntos.map((assunto, assuntoIndex) => (
                                                <Typography key={assuntoIndex} className="datajud-text">{assunto.codigo} - {assunto.nome}</Typography>
                                            )) }
                                        </Col>
                                        <Col span={24}>
                                            <Typography className="datajud-clique">Clique para abrir a timeline</Typography>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        ))}
                        <Col span={24}>
                            <Card>
                                <Row justify="space-between">
                                    <Col><Button onClick={this.onPrev} size="small" type="text" disabled={!(this.state.pagination.current > 1)}>Anterior</Button></Col>
                                    <Col><Button onClick={this.onNext} size="small" type="text" disabled={!(this.state.pagination.total > 1)}>Próximo</Button></Col>
                                </Row>
                            </Card>
                        </Col>
                    </Row>
                    <Drawer style={{top: 10}} open={this.state.itemSelect} onClose={() => this.setState({itemSelect: null})} footer={false} title={`Processo N° ${this.state.itemSelect?._source?.numeroProcesso || '-'}`}>
                        <Row style={{marginTop: 20}}>
                            <Col span={24}>
                                <Timeline mode="left" items={this.state.itemSelect?._source?.movimentos.sort((a, b) => new Date(a.dataHora) - new Date(b.dataHora)).map((mov) => { return { label: this.formatData(mov.dataHora), children: mov.nome } })} />
                            </Col>
                        </Row>
                    </Drawer>
                </Layout.Content>
            </Layout>
        )

    }

}

export default AdminWiki;